import { object, string } from "yup";
import _curry from "lodash/curry";
import {
  buildErrorMsg,
  buildMaxErrorMessage,
  useTranslation,
} from "component-library";
import { COUNTRIES_WITH_STATE_PROVINCE, FieldNames } from "./constants";

const useGetBillingAddressValidation = (skip?: boolean) => {
  const t = useTranslation();

  if (skip) {
    return object().shape({});
  }

  const getMaxError = _curry(buildMaxErrorMessage)(
    t("common.validation.maxLength")
  );
  const getReqError = _curry(buildErrorMsg)(t("common.validation.required"));
  const address1 = t("common.labels.address1");
  const city = t("common.labels.city");
  const zipPostCode = t("common.labels.zipPostCode");

  return object().shape({
    [FieldNames.AccountStreet1]: string()
      .max(50, getMaxError(address1, 50))
      .required(getReqError(address1)),
    [FieldNames.AccountStreet2]: string()
      .max(50, getMaxError(t("common.labels.address2"), 50))
      .nullable(),
    [FieldNames.AccountCity]: string()
      .max(50, getMaxError(city, 50))
      .required(getReqError(city)),
    [FieldNames.AccountRegion]: string().when(FieldNames.AccountCountry, {
      is: (selectedCountry: string) =>
        COUNTRIES_WITH_STATE_PROVINCE.includes(selectedCountry),
      then: (schema) =>
        schema.required(getReqError(t("common.labels.stateProvince"))),
    }),
    [FieldNames.AccountPostalCode]: string()
      .max(20, getMaxError(zipPostCode, 20))
      .required(getReqError(zipPostCode)),
    [FieldNames.AccountCountry]: string().required(
      getReqError(t("common.labels.country"))
    ),
  });
};

export default useGetBillingAddressValidation;
